import React from "react";
import Header from "../Header";
import Footer from "../CommonFooter";
import SEO from "@/components/Seo";
import useHeaderFooter from "@/hooks/useHeaderFooter";
import useSearchTitle from "@/hooks/useSearchTitle";
import useMobileDevice from "@/hooks/useMobileDevice";

const CommonLayout = ({ children }) => {
  useHeaderFooter();
  useSearchTitle();
  useMobileDevice();

  return (
    <>
      <Header />
      <SEO />
      {children && <div>{children}</div>}
      <Footer />
    </>
  );
};

export default CommonLayout;
